import CompanyInfoContent from './CompanyInfoContent';

export default CompanyInfoContent;
